import { ApiService } from "../api/";
import { Lead } from "./Lead";

/**
 * Functions for working with leads.
 */
export class LeadService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async upload(
		leads: Lead[],
		statusId: number,
		userId: number,
		source: string,
	): Promise<any> {
		const responseData = await this.apiService.post(
			`/api/v1/leads/upload-csv`,
			{
				leads: leads,
				statusId: statusId,
				userId: userId,
				source: source,
			},
		);
		const response = await responseData.json();

		return response;
	}

	public validateEmailAddress = async (email: string) => {
		const check = await fetch(
			`/api/v1/leads/validate-email?email=${email}`,
		);
		const exists = await check.json();
		return exists.result;
	};

	public fetchStatuses = async () => {
		let statuses = await fetch(`/api/v1/leads/statuses`);
		statuses = await statuses.json();
		return statuses;
	};
}
